import { Component, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RepairSummaryService } from '@app/repairs/services/repair-summary.service';
import { SpinnerComponent } from '@app/shared/components/spinner/spinner.component';
import { Adb2cService } from '@app/blocks/adb2c/services/adb2c/adb2c.service';
import { Subject, Subscription, takeUntil } from 'rxjs';

@Component({
    selector: 'app-repair-summary',
    imports: [ CommonModule, SpinnerComponent ],
    templateUrl: './repair-summary.component.html',
    styleUrl: './repair-summary.component.scss',
})
export class RepairSummaryComponent implements OnInit, OnDestroy {

    @Input() id: string = ""
    @Input() pageSubHeading: string = ""
    @Input() roleNuvu: string = "";
    @Input() rolePrs: string = "";
    @Input() repairSummary: any = ""
    private destroy$ = new Subject<void>();
    private userSubscription?: Subscription;

    loading: boolean = true

    constructor(
        private repairSummaryService: RepairSummaryService,
        private adb2cService: Adb2cService,
        private el: ElementRef) {
        const cpt = this.el.nativeElement;
        this.pageSubHeading = cpt.getAttribute("pageSubHeading");
        this.id = cpt.getAttribute("id");
        this.roleNuvu = cpt.getAttribute("roleNuvu");
        this.rolePrs = cpt.getAttribute("roleprs");

        console.log(cpt);
        console.log(cpt.getAttribute("roleNuvu"));
        console.log(this.roleNuvu);
        console.log(this.rolePrs);
    }

    ngOnInit() {
        this.adb2cService.getUser();
        this.getRepairSummary();
    }

    getRepairSummary() {

        this.userSubscription = this.adb2cService.activeUser.asObservable().pipe(takeUntil(this.destroy$)).subscribe(user => {
            if (user && user.sub && user[ 'tenancy_reference' ]) {
                this.repairSummaryService.getRepairs(user.sub, user[ 'tenancy_reference' ]!).subscribe({
                    next: (response) => {

                        if (response && response.repair && response.repair.repairJobs) {

                            if (response.repair.status === "ContractorAssignment") {
                                window.location.href = "/repairs/";
                                return;
                            } else if (response.repair.status !== "New") {
                                window.location.href = "/repairs/appointments/";
                                return;
                            }

                            this.repairSummary = response.repair.repairJobs[ 0 ];
                            this.loading = false;
                        }
                        else {
                            this.repairSummary = {};
                            this.loading = false;
                        }

                        console.log(this.repairSummary);

                    },
                    error: (error) => {
                        console.error(error)
                    }
                });
            }
        });
        this.loading = false;
    }

    deleteSor(sorUserCode: string) {
        this.loading = true;

        this.userSubscription = this.adb2cService.activeUser.asObservable().pipe(takeUntil(this.destroy$)).subscribe(user => {
            if (user && user.sub && user[ 'tenancy_reference' ]) {
                this.repairSummaryService.deleteRepair(user.sub, user[ 'tenancy_reference' ]!, sorUserCode).subscribe({
                    next: (response) => {
                        this.repairSummary = response;
                        console.log(this.repairSummary);

                    },
                    error: (error) => {
                        console.error(error)
                    }
                });
            }
        });

        this.loading = false;
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();

        this.userSubscription?.unsubscribe();
    }
}

